<template lang="pug">
    .pos.full-height-error.not-valid(v-if="!enabledExtensions.includes('shop')")
        Error(:message="null" :code="403")
    .pos.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .pos.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .pos(v-else)
        tabs(:items="tabs", :active-tab="$route.fullPath", @click="activateTab")
            template(slot="tabbar-buttons")
                el-button.delete-button(
                    circle,
                    v-if="!loading && form.id && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'delete')",
                    type="danger",
                    icon="el-icon-fa-trash-alt far",
                    :loading="deleting",
                    :disabled="isDisabledSubmit && !deleting",
                    @click="confirmDelete"
                )
                el-button(
                    circle,
                    icon="el-icon-fa-times fas",
                    :disabled="isDisabledSubmit",
                    @click="leave"
                )
                el-button(
                    circle,
                    v-if="!loading && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')",
                    type="primary",
                    icon="el-icon-fa-check fas",
                    :disabled="isDisabledSubmit && !savingAndClose",
                    :loading="savingAndClose",
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle,
                    v-if="!loading && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')",
                    type="success",
                    icon="el-icon-fa-save fas",
                    :disabled="isDisabledSubmit && !saving",
                    :loading="saving",
                    @click="submit"
                )
        el-card(shadow="always", v-loading="loading")
            el-form(
                label-position="top"
                :model="form"
                :rules="rules"
                :validate-on-rule-change="false"
                ref="form"
            )
                el-row.no-margin(:gutter="40")
                    el-col(:lg="14" :md="12")
                        el-form-item(:label="$t('Name')" prop="name")
                            el-input(
                                :value="form.name",
                                maxlength="255",
                                prop="name",
                                @input="update('name', $event)",
                                show-word-limit
                            )
                    el-col(:lg="10" :md="12")
                        el-form-item(:label="$t('Key')" prop="key")
                            el-input(
                                :value="form.key",
                                maxlength="255",
                                prop="name",
                                @input="update('key', $event)",
                                show-word-limit
                            )

                .flex-row
                    el-form-item.grow(:label="$t('Stock allocation')" prop="stocks")
                        el-select.is-full-width(
                            v-model="stocks"
                            placeholder=""
                            valueKey="id"
                            multiple
                            filterable
                            clearable
                            :class="{ 'loading': options.stock.loading }"
                        )
                            el-option(
                                v-for="item in options.stock.items"
                                :key="item.id"
                                :label="item.name"
                                :value="item"
                            )
                    el-form-item.grow(:label="$t('Customer group for prices')" prop="customerGroup")
                        el-select.is-full-width(
                            v-model="customerGroup"
                            :placeholder="defaultCustomerGroupName"
                            valueKey="id"
                            filterable
                            clearable
                            :class="{ 'loading': options.customerGroup.loading }"
                        )
                            el-option(
                                v-for="item in options.customerGroup.items"
                                :key="item.id"
                                :label="item.name"
                                :value="item"
                            )

                //- el-form-item(:label="$t('Street')")
                //-         el-input(:value="form.address.street" @input="update('address.street', $event)" maxlength="255" show-word-limit)
                //- el-row.no-padding(:gutter="20")
                //-         el-col(:lg="8" :md="8")
                //-                 el-form-item(:label="$t('Zipcode')")
                //-                         el-input(:value="form.address.zipcode" @input="update('address.zipcode', $event)" maxlength="255" show-word-limit)
                //-         el-col(:lg="16" :md="16")
                //-                 el-form-item(:label="$t('City')")
                //-                         el-input(:value="form.address.city" @input="update('address.city', $event)" maxlength="255" show-word-limit)
                //- el-form-item(:label="$t('Country')")
                //-         el-select.is-full-width(placeholder="" filterable v-model="form.address.country" autocomplete="no-fill")
                //-                 el-option(v-for="(label, value) in countries" :key="value" :label="label" :value="value")

                el-form-item(prop="use_stock_address_for_members")
                    el-switch(
                        v-model="useStockAddressForMembers"
                        inactive-color="#ff4949"
                        :active-text="$t('Use a stock address instead of customer shipping address')"
                    )
                transition(name="slide-decent-vertical")
                    .flex-row(v-if="useStockAddressForMembers")
                        el-form-item.grow(:label="$t('Use stock address for customers with selected tags')" prop="stockAddressMemberTags")
                            el-select.is-full-width(
                                v-model="stockAddressMemberTags"
                                placeholder=""
                                valueKey="id"
                                multiple
                                filterable
                                clearable
                                allow-create
                                default-first-option
                                :disabled="!useStockAddressForMembers"
                                :class="{ 'loading': options.memberTag.loading }"
                            )
                                el-option(
                                    v-for="item in memberTagOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item"
                                )
                        el-form-item.stock-address(:label="$t('Stock address')" prop="stock")
                            el-select.is-full-width(
                                v-model="stock"
                                placeholder=""
                                valueKey="id"
                                filterable
                                clearable
                                :disabled="!useStockAddressForMembers"
                                :class="{ 'loading': options.stock.loading }"
                            )
                                el-option(
                                    v-for="item in options.stock.items"
                                    :key="item.id"
                                    :label="item.address ? `${item.name} - ${item.address.oneLiner}` : item.name"
                                    :value="item"
                                )
                                    .stock-address-option
                                        b {{ item.name }}
                                        .address(v-if="item.address") {{ item.address.oneLiner }}

                el-form-item(prop="assign_member_tags")
                    el-switch(
                        v-model="assignMemberTags"
                        inactive-color="#ff4949"
                        :active-text="$t('Assign tags when creating a new customer')"
                    )
                transition(name="slide-decent-vertical")
                    .flex-row(v-if="assignMemberTags")
                        el-form-item.grow(:label="$t('Assign selected tags to new customers')" prop="assignableMemberTags")
                            el-select.is-full-width(
                                v-model="assignableMemberTags"
                                placeholder=""
                                valueKey="id"
                                multiple
                                filterable
                                clearable
                                allow-create
                                default-first-option
                                :disabled="!assignMemberTags"
                                :class="{ 'loading': options.memberTag.loading }"
                            )
                                el-option(
                                    v-for="item in memberTagOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item"
                                )
                .block
                    h4 {{ $t('Address') }}
                    template(v-if="form.address && !form.address.deleted")
                        Address(:data="form.address" :show-public-switch="false")
                        el-button(type="warning" size="mini" icon="el-icon-fa-trash-alt fas" @click="removePosAddress")
                            | {{ $t('Remove individual POS address') }}
                    template(v-else)
                        //- address-card.address(
                        //-     v-if="address"
                        //-     :key="address.id"
                        //-     :address="address"
                        //-     @set-marker="({ latitude, longitude }) => setMarker(address, latitude, longitude)"
                        //- )
                        //-     template(slot="title")
                        //-         h3 {{ $t('Default account address') }}
                        el-button(type="info" size="mini" icon="el-icon-fa-edit fas" @click="addPosAddress")
                            | {{ $t('Define individual POS address') }}

                .block(v-if="isTseEnabled && id")
                    h4 {{ $t('Fiscal Compliance (TSE)') }}
                    template(v-if="fiskalyClient")
                        el-descriptions(:column="1" border size="small")
                            el-descriptions-item(:label="$t('Client ID')")
                                span {{ fiskalyClient.fiskaly_client_id }}
                            el-descriptions-item(:label="$t('Serial Number')")
                                span {{ fiskalyClient.serial_number || '-' }}
                            el-descriptions-item(:label="$t('Status')")
                                el-tag(
                                    :type="fiskalyClient.state === 'REGISTERED' ? 'success' : 'danger'"
                                    size="small"
                                ) {{ $t('fiskaly.' + fiskalyClient.state) }}
                    template(v-else)
                        el-alert(
                            :title="$t('No Fiskaly client registered for this POS.')"
                            type="info"
                            show-icon
                            :closable="false"
                        )
                        el-button.register-fiskaly-button(
                            type="primary"
                            size="mini"
                            plain
                            round
                            icon="el-icon-fa-plug fas"
                            :loading="registeringFiskalyClient"
                            @click="registerFiskalyClient"
                        ) {{ $t('Register Fiskaly Client') }}

                .block(v-if="communicationEnabled")
                    h4.connections-title {{ $t('Connections') }}
                    p.block-subtitle {{ $t('Customer Communication: email mailbox & WhatsApp for this point of sale.') }}
                    communication-connections(
                        :cms-id="activeCms.id"
                        :mailbox="mailboxModel"
                        scope="pos"
                        :point-of-sale-id="form.id"
                        @persist-mailbox="persistPosMailbox"
                        @delete-mailbox="persistPosMailbox"
                    )
                    el-form-item.pos-default-signature(v-if="mailboxModel.id" :label="$t('Default email signature')")
                        el-select.is-full-width(v-model="defaultSignatureId" clearable :placeholder="$t('No signature')")
                            el-option(v-for="signature in signatures" :key="signature.id" :label="signature.name" :value="signature.id")
                        span.help {{ $t('This point of sale\'s signature, appended to its email replies. The replying agent and point of sale name are filled in automatically.') }}

        .form-buttons
            el-button(
                round,
                v-if="!loading && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')",
                icon="el-icon-fa-times fas",
                :disabled="isDisabledSubmit",
                @click="leave"
            ) {{ $t("Dismiss") }}
            el-button(
                round,
                v-if="!loading && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')",
                type="primary",
                icon="el-icon-fa-check fas",
                :loading="savingAndClose",
                :disabled="isDisabledSubmit && !savingAndClose",
                @click="submit($event, listRoute)"
            ) {{ $t("Save and close") }}
            el-button(
                round,
                v-if="!loading && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')",
                type="success",
                icon="el-icon-fa-save fas",
                :loading="saving",
                :disabled="isDisabledSubmit && !saving",
                @click="submit"
            ) {{ $t("Save") }}
</template>

<i18n>
{
    "en": {
        "fiskaly.REGISTERED": "Registered",
        "fiskaly.DEREGISTERED": "Deregistered"
    },
    "de": {
        "Point of Sale": "Kasse",
        "Point of Sale saved successfully!": "Kasse wurde erfolgreich gespeichert",
        "Point of Sale could not be saved.": "Kasse konnte nicht gespeichert werden",
        "Mailbox saved": "Postfach gespeichert",
        "The mailbox could not be saved.": "Das Postfach konnte nicht gespeichert werden.",
        "Point of Sale could not be fetched.": "Kasse konnte nicht gefunden werden.",
        "Point of Sale Not Found": "Kasse nicht gefunden",
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Use a stock address instead of customer shipping address": "Eine Lageradresse anstelle der Kunden-Versandadresse verwenden",
        "Use stock address for customers with selected tags": "Lageradresse für Kunden mit ausgewählten Tags verwenden",
        "Stock address": "Lageradresse",
        "Assign tags when creating a new customer": "Tags zuweisen, wenn ein neuer Kunde erstellt wird",
        "Assign selected tags to new customers": "Ausgewählte Tags neuen Kunden zuweisen",
        "Customer group for prices": "Kundengruppe für Preise",
        "Name": "Name",
        "Key": "Eindeutige Kennung",
        "Address": "Adresse",
        "Define individual POS address": "Individuelle Kassen-Adresse festlegen",
        "Remove individual POS address": "Individuelle Kassen-Adresse entfernen",

        "Stock allocation": "Lagerzuordnung",
        "enter stock name": "Lager-Name eingeben",
        "assigned stock(s)": "Zugeordnete(s) Lager",
        "add stocks:": "Lager hinzufügen:",
        "disconnect stock": "Zuordnung löschen",
        "no stocks assigned": "Keine Lager zugeordnet",

        "Fiscal Compliance (TSE)": "Fiskalisierung (TSE)",
        "Connections": "Verbindungen",
        "Customer Communication: email mailbox & WhatsApp for this point of sale.": "Kundenkommunikation: E-Mail-Postfach & WhatsApp für diese Kasse.",
        "Default email signature": "Standard-E-Mail-Signatur",
        "No signature": "Keine Signatur",
        "This point of sale's signature, appended to its email replies. The replying agent and point of sale name are filled in automatically.": "Die Signatur dieser Kasse, die an ihre E-Mail-Antworten angehängt wird. Name des antwortenden Mitarbeiters und der Kasse werden automatisch eingesetzt.",
        "Client ID": "Client-ID",
        "Serial Number": "Seriennummer",
        "Status": "Status",
        "No Fiskaly client registered for this POS.": "Kein Fiskaly-Client für diese Kasse registriert.",
        "Register Fiskaly Client": "Fiskaly-Client registrieren",
        "Fiskaly client registered successfully.": "Fiskaly-Client erfolgreich registriert.",
        "Failed to register Fiskaly client.": "Fiskaly-Client konnte nicht registriert werden.",
        "fiskaly.REGISTERED": "Registriert",
        "fiskaly.DEREGISTERED": "Abgemeldet"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';
import { checkRestrictions } from '@/helpers'

import pinia from '@/pinia';
import router from '@/router';
import { useSetupStore, useShopPosStore } from '@/stores';

import Tabs from "@/components/Tabs";
import Error from '@/components/Error';
import Address from "./Partials/Address";
import CommunicationConnections from "@/extensions/communication/views/ChannelAccount/Connections";
import emptyMailbox from "@/extensions/communication/utils/emptyMailbox";
import SignatureApi from "@/extensions/communication/store/api/signature";

import StockApi from "@/extensions/shop/store/api/stock";
import PosApi from "@/extensions/shop/store/api/pos";

import countries from "i18n-iso-countries";
import de from "i18n-iso-countries/langs/de.json";
countries.registerLocale(de);

export default {
    name: "POSForm",
    data() {
        return {
            listRoute: { name: "settings-pos" },
            loading: false,
            error: false,
            pathNotValid: false,

            saving: false,
            savingAndClose: false,
            deleting: false,
            registeringFiskalyClient: false,
            // CMS email signatures available for this POS's per-store default.
            signatures: [],
        };
    },
    components: {
        Tabs,
        Error,
        Address,
        CommunicationConnections,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        },
        // Re-seed a fully-keyed reactive mailbox whenever it's cleared — e.g. after
        // deleting the POS mailbox, the store leaves form.mailbox null, and the re-add
        // drawer would otherwise bind to a throwaway {} and freeze every input.
        'form.mailbox': {
            immediate: true,
            handler(mailbox) {
                if (!mailbox || !('address' in mailbox)) {
                    this.ensureMailbox();
                }
            }
        }
    },
    computed: {
        tabs() {
            const id = this.$route.params.id;
            const tabs = [
                {
                    name: this.$t("Point of Sale"),
                    path: `/pos/${id}`,
                    icon: {
                        name: "cash-register",
                        group: "fas",
                    },
                },
            ];
            return tabs;
        },
        stocks: {
            get() {
                return _.get(this.form, 'stocks', []);
            },
            set(value) {
                this.updateForm({ path: 'stocks', value });
            },
        },
        useStockAddressForMembers: {
            get() {
                return _.get(this.form, 'use_stock_address_for_members', false);
            },
            set(value) {
                this.updateForm({ path: 'use_stock_address_for_members', value });
            },
        },
        stockAddressMemberTags: {
            get() {
                // return _.get(this.form, 'stockAddressMemberTags') || [];
                let tags = _.get(this.form, 'stockAddressMemberTags') || [];
                return tags.map(tag => {
                    if (tag.id.startsWith('new:')) return tag.name
                    else return tag
                })
            },
            set(value) {
                let memberTags = []
                value.forEach(tag => {
                    if (typeof tag === 'string' || tag instanceof String) {
                        memberTags.push({
                            id: uniqid('new:'),
                            name: tag,
                        })
                    } else {
                        memberTags.push(tag)
                    }
                })

                this.updateForm({ path: 'stockAddressMemberTags', value: memberTags });
            },
        },
        assignMemberTags: {
            get() {
                return _.get(this.form, 'assign_member_tags', false);
            },
            set(value) {
                this.updateForm({ path: 'assign_member_tags', value });
            },
        },
        stock: {
            get() {
                return _.get(this.form, 'stock', null);
            },
            set(value) {
                this.updateForm({ path: 'stock', value });
            },
        },
        customerGroup: {
            get() {
                return _.get(this.form, 'customerGroup', null);
            },
            set(value) {
                this.updateForm({ path: 'customerGroup', value });
            },
        },
        assignableMemberTags: {
            get() {
                let tags = _.get(this.form, 'assignableMemberTags') || [];
                return tags.map(tag => {
                    if (tag.id.startsWith('new:')) return tag.name
                    else return tag
                })
            },
            set(value) {
                let memberTags = []
                value.forEach(tag => {
                    if (typeof tag === 'string' || tag instanceof String) {
                        memberTags.push({
                            id: uniqid('new:'),
                            name: tag,
                        })
                    } else {
                        memberTags.push(tag)
                    }
                })
                this.updateForm({ path: 'assignableMemberTags', value: memberTags });
            },
        },
        memberTagOptions() {
            let items = this.options.memberTag.items || [];
            const itemIDs = items.map(item => item.id);

            this.assignableMemberTags.forEach(tag => {
                // || tag.id.startsWith('new:')
                if (!itemIDs.includes(tag.id)) {
                    items.push(tag);
                }
            });

            this.stockAddressMemberTags.forEach(tag => {
                // || tag.id.startsWith('new:')
                if (!itemIDs.includes(tag.id)) {
                    items.push(tag);
                }
            });

            return items;
        },
        id() {
            return _.get(this.form, "id", false);
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        countries() {
            return countries.getNames("de");
        },
        defaultCustomerGroupName() {
            return _.get(this.activeCms, 'shop.defaultCustomerGroup.name')
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        communicationEnabled() {
            return this.enabledExtensions.includes('communication')
                && checkRestrictions(['ex:comm', 'ex:comm:accounts']);
        },
        isTseEnabled() {
            return _.get(this.activeCms, 'is_tse', false);
        },
        fiskalyClient() {
            return _.get(this.form, 'fiskalyClient', null);
        },
        posStore() {
            return useShopPosStore();
        },
        form() {
            return this.posStore.form;
        },
        // The POS mailbox is part of the form payload and saved with it. The reactive
        // object is attached in the load path (ensureMailbox) — this stays a pure
        // getter (no writes inside a computed).
        mailboxModel() {
            return this.form.mailbox || {};
        },
        // Per-POS default signature (a nested {id, name} object on the form, mirroring
        // how the channel defaultSignature round-trips). Bridged to the el-select id.
        defaultSignatureId: {
            get() {
                return _.get(this.form, 'defaultSignature.id') || null;
            },
            set(value) {
                const signature = this.signatures.find(item => item.id === value);
                this.$set(this.form, 'defaultSignature', value ? { id: value, name: signature ? signature.name : '' } : { id: null });
            }
        },
        rules() {
            return this.posStore.rules;
        },
        options() {
            return this.posStore.options;
        },
        initialized() {
            return this.posStore.formInitialized;
        },
        validateOnEnter() {
            return this.posStore.formValidateOnEnter;
        },
    },
    methods: {
        // handleSelectChange() {
        //     var slctdStock = _.find(
        //         this.fetchedStocks,
        //         (stock) => this.value == stock.id
        //     );
        //     this.addStock(slctdStock);
        //     this.value = ""
        // },
        // handleSearchChange(e) {
        //     var dataIn = {
        //         filters: [
        //             {
        //                 key: "name",
        //                 like: e,
        //             },
        //         ],
        //     };
        //     this.selectLoading = true
        //     StockApi.fetchStocksPaginated(dataIn, this.activeCms.shop.id).then(
        //         (data) => {
        //             console.log(JSON.stringify(data));
        //             this.selectLoading = false
        //             this.fetchedStocks = data.items;
        //         }
        //     );
        // },
        initialize() {
            if (!this.enabledExtensions.includes('shop') || !this.enabledExtensions.includes('shop:point-of-sale')) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                let actions = [
                    this.fetchStockOptions(this.activeCms.shop.id),
                    this.fetchMemberTagOptions(this.activeCms.id),
                    this.fetchCustomerGroupOptions(this.activeCms.shop.id),
                ];

                const fetchDependencies = () => {
                    return Promise.all(actions);
                };

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    this.posStore.resetForm();
                    this.ensureMailbox();

                    // fetchDependencies().then(() => store.commit('ext_shop_pos/updateRules', rules))
                    fetchDependencies()
                        .then(() => {
                            setTimeout(this.$refs.form.clearValidate, 0)
                        })
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchPos(this.$route.params.id)
                        .then(() => {
                            // store.commit('ext_shop_pos/resetUI')
                            this.ensureMailbox();

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    // store.commit('ext_shop_pos/resetRules');
                                    // store.commit('ext_shop_pos/resetUI')
                                    this.loading = false;
                                })
                                .catch(handleDependencyError);
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Point of Sale Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Point of Sale could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-xmark',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
            // if (this.$route.params.id === "new") {
            //     this.resetForm();
            // } else if (!isNaN(this.$route.params.id)) {
            //     this.fetch();
            // }
        },
        addPosAddress() {
            this.posStore.addFormAddress();
        },
        removePosAddress() {
            this.posStore.removeFormAddress();
        },
        // fetch() {
        //     this.loading = true;
        //     this.fetchPos(this.$route.params.id)
        //         .catch((err) => {
        //             console.error(err);
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //         });
        // },
        update(key, event) {
            this.updateForm({
                path: key,
                value: event,
            });
        },
        submit(event, redirect = false) {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (redirect) this.savingAndClose = true;
                    else this.saving = true;

                    let save = this.createPos;
                    if (this.id) save = this.updatePos;

                    // Multistore: a terminal belongs to the store that is selected, not to
                    // whichever store of this shop the backend happens to see first.
                    const payload = { ...this.form, cms: { id: this.activeCms.id } };

                    save(payload)
                        .then(pos => {
                            this.$notify.success({
                                title: this.$t("Point of Sale saved successfully!"),
                                iconClass: "fas el-icon-fa-check",
                                position: "bottom-left",
                                customClass: "dark",
                                duration: 8000,
                            });

                            if (redirect) {
                                router.push(redirect);
                            } else {
                                // this.fetch();
                                if (this.$route.params.id === 'new') {
                                    const route = router.currentRoute
                                    route.params.id = pos.id
                                    router.replace(route)
                                }
                            }
                        })
                        .catch((err) => {
                            console.error(err);

                            this.$notify.error({
                                title: this.$t("An error occurred!"),
                                message: this.$t("Point of Sale could not be saved."),
                                iconClass: "fas el-icon-fa-times",
                                position: "bottom-left",
                                customClass: "dark",
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;
                        });
                } else {
                    this.$notify.warning({
                        title: this.$t("Form is not valid!"),
                        message: this.$t("Correct your input and submit again."),
                        iconClass: "fas el-icon-fa-exclamation-circle",
                        position: "bottom-left",
                        customClass: "dark",
                        duration: 8000,
                    });
                }
            });
        },
        confirmDelete() {
            this.$confirm(
                this.$t('This will permanently delete the point of sale. Continue?'),
                this.$t('Delete Point of Sale'),
                {
                    confirmButtonText: this.$t('Delete'),
                    confirmButtonClass: 'el-button--danger',
                    cancelButtonText: this.$t('Cancel'),
                    type: 'warning',
                }
            ).then(() => {
                this.deleting = true;
                this.posStore.deletePointOfSale(this.form.id)
                    .then(() => {
                        this.$notify.success({
                            title: this.$t('Point of sale deleted successfully!'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 5000,
                        });
                        router.push(this.listRoute);
                    })
                    .catch(() => {
                        this.deleting = false;
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Point of sale could not be deleted.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        });
                    });
            }).catch(() => {});
        },
        leave() {
            router.push(this.listRoute);
        },
        checkRestrictions,
        setInitializedFlag(flag) {
            this.posStore.setFormInitialized(flag);
        },
        resetForm() {
            this.posStore.resetForm();
        },
        updateForm(payload) {
            this.posStore.updateForm(payload);
        },
        addStock(stock) {
            this.posStore.addStock(stock);
        },
        removeStock(stockId) {
            this.posStore.removeStock(stockId);
        },
        // The fetch returns null when no mailbox exists yet — lazily attach a reactive
        // object so the embedded SmtpCredentials can write its fields onto the form.
        // Done in the load path (not in the computed getter) to avoid a side-effecting
        // computed.
        ensureMailbox() {
            // SmtpCredentials binds each field via a computed that only becomes reactive
            // for keys present when it FIRST reads the object. A null or bare-{} mailbox
            // (fresh POS, or after deleting the mailbox) therefore freezes every input,
            // and backfilling keys onto that same object does not help — the computed has
            // already read the missing key without subscribing. So REPLACE it with a
            // fresh fully-keyed object (merging any partial values over the scaffold);
            // the replacement makes the computeds re-read and subscribe. See emptyMailbox().
            if (!this.form.mailbox || !('address' in this.form.mailbox)) {
                this.$set(this.form, 'mailbox', Object.assign(emptyMailbox(), this.form.mailbox || {}));
            }
        },
        fetchPos(posId) {
            return this.posStore.fetchPointOfSale(posId);
        },
        createPos(pos) {
            return this.posStore.create(pos);
        },
        updatePos(pos) {
            return this.posStore.update(pos);
        },
        // Save ONLY the mailbox onto this (already-persisted) POS — a PARTIAL update
        // ({id, mailbox}) via the API directly, so the POS's other, possibly-unsaved form
        // fields are never touched (that is the whole point of the drawer's "Save"). One
        // handler covers save AND delete: form.mailbox already carries the intent (edited
        // values, or `deleted: true` set by removeMailbox).
        persistPosMailbox() {
            return PosApi.update({ id: this.form.id, mailbox: this.form.mailbox })
                .then((pos) => {
                    // Reflect the saved mailbox (its id/validation) back without touching
                    // other fields; the 'form.mailbox' watcher re-seeds an empty one after
                    // a deletion (mailbox comes back null).
                    this.$set(this.form, "mailbox", _.get(pos, "mailbox") || null);
                    this.$notify.success({
                        title: this.$t("Mailbox saved"),
                        iconClass: "fas el-icon-fa-check",
                        position: "bottom-left",
                        customClass: "dark",
                        duration: 6000,
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$notify.error({
                        title: this.$t("An error occurred!"),
                        message: this.$t("The mailbox could not be saved."),
                        iconClass: "fas el-icon-fa-times",
                        position: "bottom-left",
                        customClass: "dark",
                        duration: 8000,
                    });
                });
        },
        fetchStockOptions(shopID) {
            return this.posStore.fetchStockOptions(shopID);
        },
        fetchMemberTagOptions(cmsID) {
            return this.posStore.fetchMemberTagOptions(cmsID);
        },
        fetchCustomerGroupOptions(shopID) {
            return this.posStore.fetchCustomerGroupOptions(shopID);
        },
        fetchSignatures() {
            const cms = this.activeCms;
            if (!cms || !cms.id) return;
            SignatureApi.fetchList(cms.id)
                .then(list => { this.signatures = list || []; })
                .catch(() => { /* signatures are optional */ });
        },
        activateTab(item) {
            return useSetupStore().activateTab(item)
        },
        registerFiskalyClient() {
            this.registeringFiskalyClient = true;
            this.posStore.registerFiskalyClient(this.id)
                .then(() => {
                    this.$notify.success({
                        title: this.$t('Fiskaly client registered successfully.'),
                        position: 'bottom-left',
                        customClass: 'dark',
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        title: this.$t('Failed to register Fiskaly client.'),
                        position: 'bottom-left',
                        customClass: 'dark',
                    });
                })
                .finally(() => {
                    this.registeringFiskalyClient = false;
                });
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.loading = true;
        this.setInitializedFlag(false);
        next();
        this.initialize();
    },
    beforeRouteLeave(to, from, next) {
        next();
        this.setInitializedFlag(false);
        this.posStore.resetForm();
    },
    mounted() {
        this.initialize();
        this.fetchSignatures();
    },
};
</script>

<style lang="sass" scoped>
.connections-title
    margin-bottom: 4px
.block-subtitle
    margin: 0 0 14px
    line-height: 1.4
    font-size: .85rem
    color: #909399
.label
    margin-top: 12px
    margin-bottom: 6px
.top-buttons
    justify-content: flex-end
    display: flex
    padding-bottom: 4px
.stock-address
    min-width: 480px
.stock-address-option
    line-height: 1.2
    padding: 6px 0
    .address
        font-size: 0.85em
.switch
    min-width: 500px
.register-fiskaly-button
    margin-top: 0.75rem
.pos-default-signature
    margin-top: 1rem
</style>
